import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { SupabaseProvider } from './context/SupabaseContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import CreatePoll from './pages/CreatePoll';
import HostDashboard from './pages/HostDashboard';
import ParticipantView from './pages/ParticipantView';
import './App.css';

function App() {
  return (
    <SupabaseProvider>
      <Router>
        <div className="min-h-screen bg-white">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/create" element={<CreatePoll />} />
            <Route path="/poll/:id/host" element={<HostDashboard />} />
            <Route path="/poll/:id" element={<ParticipantView />} />
          </Routes>
        </div>
      </Router>
    </SupabaseProvider>
  );
}

export default App;